import closeOuter from './lib/CloseOuter';

const readspeaker = (button: HTMLElement) => {
  const bodyClick = (event:Event) => {
    const clicked = event.target as HTMLElement;
    const panel = document.querySelector('#rs-controlpanel') as HTMLElement;
    const check = closeOuter(clicked, 'rs-controlpanel', '#');
    if (check && panel) {
      document.removeEventListener('click', bodyClick);
      panel.style.display = 'none';
    }
  };
  let playing = false;
  let first = true;
  const player:HTMLElement = document.querySelector('.rsbtn_play');
  const icon = button.querySelector('.page-player__icon');

  button.addEventListener('click', () => {
    const pause: HTMLElement = document.querySelector('.rsicn-pause');

    if (first) {
      first = false;
      setTimeout(() => {
        const extraMenu = document.querySelector('#rs-controlpanel');
        if (extraMenu) {
          const playPause = extraMenu.querySelector('.rs-controlpanel-playpause');

          playPause?.addEventListener('click', () => {
            icon?.classList.toggle('fa-circle-play');
            icon?.classList.toggle('fa-circle-pause');
            playing = !playing;
          });
        }

        const downMenu = document.querySelector('#rsmpl_container');

        if (downMenu) {
          const playPauseDown = downMenu.querySelector('.rsmpl-playpause button');
          const stopDown = downMenu.querySelector('.rsmpl-stop button');

          stopDown?.addEventListener('click', () => {
            icon?.classList.add('fa-circle-play');
            icon?.classList.remove('fa-circle-pause');
            playing = false;
          });

          playPauseDown?.addEventListener('click', () => {
            icon?.classList.toggle('fa-circle-play');
            icon?.classList.toggle('fa-circle-pause');
            playing = !playing;
          });
        }
      }, 500);
    }

    if (!playing) {
      player?.click();
      setTimeout(() => {
        document.addEventListener('click', bodyClick);
      }, 100);
    } else {
      pause?.click();
    }

    icon?.classList.toggle('fa-circle-play');
    icon?.classList.toggle('fa-circle-pause');
    playing = !playing;
  });
};

export default readspeaker;
